<template>
  <div class="card is-min-width-800" v-if="ligneCommande">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('demandeLogistique.titleImpression') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
        <div>
          <v-client-table
            :data="listeDemandesImpression"
            :columns="columns"
            :options="options"
            ref="table">
            <template #dateDemande="props">
              <section class="is-flex is-justify-content-space-between">
                <router-link-blank
                  :to="{
                    name: 'c.logistique.demande_impression',
                    params: { id: props.row.id }
                  }"
                  class="lien"
                  :message="getDate(props.row.dateDemande)">
                </router-link-blank>
                <b-icon
                  v-if="getCouleurInformation(props.row.couleur)"
                  :icon="getCouleurInformation(props.row.couleur).icon"
                  :custom-class="getCouleurInformation(props.row.couleur).type"
                  size="is-small"
                  :class="{ 'demandeImpressionwhiteColorBorder' :
                    getCouleurInformation(props.row.couleur).key === constantes.COULEUR_BLANC}">
                </b-icon>
              </section>
            </template>
            <template #etat="props">
              <span> {{ $t(getEtatInformation(props.row.etat).libelle) }} </span>
            </template>
            <template #client="props">
              <router-link-blank
                :to="{
                  name: 'c.bodac.clients/contacts-client',
                  params: { id: props.row.client.id}
                }"
                class="lien"
                :message="props.row.client.nomCommercial">
              </router-link-blank>
            </template>
            <template #contactDemandeur="props">
              <span> {{ func.getContactFullName(props.row) }} </span>
            </template>
            <template #codeDispositif="props">
              <router-link-blank
                v-if="props.row.dispositif"
                :to="{
                  name: 'c.gabed.emplacement-detailDispositif',
                  params: {
                    idDispositif: props.row.dispositif.id,
                  }
                }"
                class="lien"
                :message="props.row.dispositif.code">
              </router-link-blank>
            </template>
            <template #typesMateriels="props">
              <span> {{ getMaterielTypeLibelle(props.row.dispositif) }} </span>
            </template>
            <template #adresseDispositif="props">
              <span v-if="props.row.dispositif">
                {{ adresse(props.row.dispositif.adresse) }}
              </span>
            </template>
            <template #campagne="props">
              <router-link-blank
                v-if="props.row.campagne"
                :to="{
                  name: 'c.bodac.campagne',
                  params: {
                    id: props.row.campagne.id,
                  }
                }"
                class="lien"
                :message="getCampagne(props.row.campagne)">
              </router-link-blank>
            </template>
            <template #soldeStock="props">
              {{ props.row.soldeStock }}
            </template>
            <template #update="props" >
              <btn-action-icon
                :permission="constantes.permDemandeImpression.supprimer"
                @is-click="popupUpdate(props.row)"
                icon-type="is-success"
                icon="pencil-box-outline">
              </btn-action-icon>
            </template>
            <template #delete="props" >
              <btn-action-icon
                :disabled="props.row.devisCommandes && props.row.devisCommandes.length > 0"
                :tooltipLabelDisabled=
                  "$t('demandeLogistique.tableImpression.action.deleteForbidden')"
                :permission="constantes.permDemandeImpression.supprimer"
                @is-click="popupSupp(props.row)"
                icon-type="is-danger"
                icon="delete-forever">
              </btn-action-icon>
            </template>
          </v-client-table>
        </div>
        <footer>
          <b-field>
            <div class="boutonAction center">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.close')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
    <b-modal v-model="popUpModification" has-modal-card class="modal">
      <pop-up-edition-demande-impression
        @refreshList="refreshList"
        :ligneCommande="ligneCommande"
        :detailsDemandeImpression="demandeAModifier">
      </pop-up-edition-demande-impression>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('listeDemandeImpression.popUpSuppression')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteDemande"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import formatDate from '@/services/general/formatDate';
import {
  COULEUR_BLANC,
  COULEUR_IMPRESSION,
  ETAT_DEMANDE_IMPRESSION,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { deleteDemandeImpression } from '@/api/logistique/demandeImpression';
import messageErreur from '@/services/general/messageErreur';
import PopUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageSucces from '@/services/general/messageSucces';
import getContactFullName from '@/services/contact/contactHelper';
import PopUpEditionDemandeImpression
  from '@/components/commande/logistique/p_editionDemandeImpresssion';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_demandesImpressions',
  props: {
    ligneCommande: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        ETAT_DEMANDE_IMPRESSION,
        COULEUR_IMPRESSION,
        permDemandeImpression: DEMANDE_IMPRESSION,
        COULEUR_BLANC,
      },
      func: { getContactFullName },
      listeDemandesImpression: [],
      popUpSuppression: false,
      demandeASupp: null,
      popUpModification: false,
      demandeAModifier: null,
    };
  },
  components: {
    RouterLinkBlank,
    BtnActionIcon,
    PopUpPrevention,
    PopUpEditionDemandeImpression,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    materielType() {
      return this.parametre(PARAMETRES_KEYS.materielType);
    },
    columns() {
      return [
        'dateDemande',
        'etat',
        'client',
        'contactDemandeur',
        'codeDispositif',
        'typesMateriels',
        'adresseDispositif',
        'campagne',
        'soldeStock',
        'update',
        'delete',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateDemande: this.$i18n.t('demandeLogistique.tableImpression.dateDemande'),
          etat: this.$i18n.t('demandeLogistique.tableImpression.etat'),
          client: this.$i18n.t('demandeLogistique.tableImpression.client'),
          contactDemandeur: this.$i18n.t('demandeLogistique.tableImpression.contactDemandeur'),
          codeDispositif: this.$i18n.t('demandeLogistique.tableImpression.codeDispositif'),
          typesMateriels: this.$i18n.t('demandeLogistique.tableImpression.typesMateriels'),
          adresseDispositif: this.$i18n.t('demandeLogistique.tableImpression.adresseDispositif'),
          campagne: this.$i18n.t('demandeLogistique.tableImpression.campagne'),
          soldeStock: this.$i18n.t('demandeLogistique.tableImpression.soldeStock'),
          update: '',
          delete: '',
        },
        sortable: [
          'dateDemande',
          'etat',
          'client',
          'codeDispositif',
          'campagne',
        ],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        columnsClasses: {
          delete: 'colonneSelected-35 ',
          update: 'colonneSelected-35 ',
        },
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getDate(date) {
      return formatDate(date);
    },
    getEtatInformation(etat) {
      return this.constantes.ETAT_DEMANDE_IMPRESSION.find(
        (etatDemandeImpression) => etat === etatDemandeImpression.key,
      );
    },
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
    getMaterielTypeLibelle(dispositif) {
      if (!dispositif) return '';
      return this.materielType
        .filter(mat => dispositif.materiels.some(el => el.typeId === mat.id))
        .map(el => el.libelle)
        .join(', ');
    },
    getCampagne(campagne) {
      return campagne?.libelle ?? '';
    },
    getCouleurInformation(couleur) {
      return this.constantes.COULEUR_IMPRESSION.find(
        (couleurImpression) => couleur === couleurImpression.key,
      );
    },
    async deleteDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteDemandeImpression(this.demandeASupp.id);
        const indexDemandeASupp = this.ligneCommande.demandesImpressions.findIndex(d => {
          return this.demandeASupp.id === d.id;
        });
        if (indexDemandeASupp > -1) {
          this.ligneCommande.demandesImpressions.splice(indexDemandeASupp, 1);
        }
        this.tri();
        this.demandeASupp = null;
        this.popUpSuppression = false;
        loadingComponent.close();
        messageSucces(this.$i18n.t('demandeLogistique.popUpSuppression.success'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    popupSupp(demande) {
      if (!this.checkPermissions(this.constantes.permDemandeImpression.supprimer)) {
        return;
      }
      this.demandeASupp = demande;
      this.popUpSuppression = true;
    },
    popupUpdate(demande) {
      if (!this.checkPermissions(this.constantes.permDemandeImpression.maj)) {
        return;
      }
      demande.dateDemande = new Date(demande.dateDemande);
      this.demandeAModifier = cloneDeep(demande);
      this.popUpModification = true;
    },
    tri() {
      this.listeDemandesImpression = this.listeDemandesImpression.sort(
        (a, b) => {
          return new Date(a.dateDemande) - new Date(b.dateDemande);
        });
    },
    refreshList(demande) {
      const index = this.ligneCommande.demandesImpressions.findIndex(d => d.id === demande.id);
      if (index > -1) this.ligneCommande.demandesImpressions.splice(index, 1, demande);
      this.listeDemandesImpression = cloneDeep(this.ligneCommande.demandesImpressions);
      this.tri();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.materielType]);
      this.listeDemandesImpression = this.ligneCommande.demandesImpressions;
      this.tri();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
